import React, { useState, useEffect } from "react";
import useFetch from "../../../../hooks/useFetch";
import ShareStepper from "../../../shares/stepper/Stepper";
import {
  Select,
  MenuItem,
  FormControl,
  Checkbox,
  FormHelperText,
  TextField,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import ShareTable from "../../../shares/tables/ShareTable";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import Search from "../../../shares/search/Search";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import useFormattedLocalDate from "../../../../hooks/useFormattedLocalDate";
import AddTaskOutlinedIcon from "@mui/icons-material/AddTaskOutlined";
import {
  PageHeader,
  SectionCard,
} from "../../../shares/dashboard/DashboardWidgets";

const REQUIRED_QUESTIONS = 10;

const QuestionCategory = () => {
  const navigate = useNavigate();
  const formatDate = useFormattedLocalDate();

  const [selectedQuestion, setSelectedQuestion] = useState([]);

  const [call, setCall] = useState({
    ExamName: "",
    exam_headline: "",
    exam_available_time_start: "",
    exam_available_time_end: "",
    exam_maxenterance_time: "",
    exam_question_bank: "",
    questions: [],
    // exam_answer_file: Empty,
  });
  const [activeStep, setActiveStep] = useState(0);
  const [questions, setQuestion] = useState();
  const [newQuestion, setNewQuestion] = useState();
  const [gg, setGg] = useState();
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleNext = (event) => {
    event.preventDefault();
    setActiveStep((prevStep) => prevStep + 1);
  };
  const handleBack = (event) => {
    event.preventDefault();

    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    const currentIndex = selectedQuestion.indexOf(value);
    const newChecked = selectedQuestion;

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setSelectedQuestion([...newChecked]);
  };

  const onSubmit = (e) => {
    newExam.reFetch();
  };

  const getQuestion = useFetch({
    method: "GET",
    url: "management/questions/",
    params: { page: searchParams.get("page") || 1, search: searchParams.get("search") || "" },
    safeRead: true,
    noHeader: false,
    trigger: true,
    setter: setQuestion,
  });

  const getGg = useFetch({
    method: "GET",
    url: `management/groups/?page_size=1000`,
    noHeader: false,
    trigger: true,
    setter: setGg,
  });

  const newExam = useFetch({
    method: "POST",
    url: `management/exams/`,
    noHeader: false,
    trigger: false,
    data: call,
  });

  const columns = [
    {
      id: "select",
      label: "",
      render: (row) => (
        <Checkbox
          value={row.question_id}
          onChange={handleCheckboxChange}
          checked={selectedQuestion.indexOf(row.question_id) !== -1}
          inputProps={{ "aria-label": "controlled" }}
        />
      ),
    },
    { id: "question_headline", label: "عنوان" },
    {
      id: "question_img",
      label: "تصویر سوال",
      render: (row) =>
        row.question_img ? (
          <img
            src={row.question_img}
            className="relative z-0 mx-auto max-h-[6rem] w-full max-w-[10rem] rounded-card border border-rule-subtle object-cover transition-transform duration-200 hover:z-10 hover:scale-[2.5]"
            alt="تصویر سوال"
          />
        ) : (
          <span className="text-ink-subtle">—</span>
        ),
    },
    { id: "question_answer", label: "گزینه صحیح" },
  ];

  useEffect(() => {
    setCall({
      ...call,
      questions: selectedQuestion,
    });
  }, [selectedQuestion]);

  useEffect(() => {
    if (newExam.status === 201) {
      toast.success("آزمون با موفقیت ساخته شد!", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: "light",
        rtl: true,
      });
      navigate("/admin/exams");
    }
  }, [newExam.status]);

  const steps = ["مرحله اول", "مرحله دوم"];

  const navBtnBase =
    "inline-flex items-center rounded-soft px-2xl py-sm text-base transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50 motion-reduce:transition-none";
  const navBtnGhost = `${navBtnBase} border border-rule bg-surface text-ink-muted hover:bg-surface-sunken hover:text-ink`;
  const navBtnPrimary = `${navBtnBase} bg-primary text-white hover:bg-primary-hover active:bg-primary-active`;

  return (
    <div className="flex flex-col gap-xl pb-4xl">
      <PageHeader
        title="ساخت آزمون جدید"
        description="ابتدا ۱۰ سوال را انتخاب و سپس مشخصات آزمون را تعیین کنید"
        icon={AddTaskOutlinedIcon}
      />

      <SectionCard>
        <ShareStepper
          steps={steps}
          activeStep={activeStep}
          onNext={handleNext}
          onBack={handleBack}
        />
      </SectionCard>

      {activeStep === 0 ? (
        <div className="flex flex-col gap-lg">
          <Search getFiltered={getQuestion} />
          <ShareTable
            data={questions?.results ?? []}
            columns={columns}
            getPage={getQuestion}
            totalCount={questions?.count}
            page={Number(searchParams.get("page")) || 1}
            setPage={setSearchParams}
          />
          <div className="flex flex-wrap items-center justify-between gap-md rounded-panel border border-rule-subtle bg-surface p-lg shadow-card">
            <span
              className={`text-sm ${
                selectedQuestion.length === REQUIRED_QUESTIONS
                  ? "text-success"
                  : "text-ink-muted"
              }`}
            >
              سوال‌های انتخاب‌شده:{" "}
              <span className="font-semibold tabular-nums">
                {selectedQuestion.length.toLocaleString("fa-IR")} /{" "}
                {REQUIRED_QUESTIONS.toLocaleString("fa-IR")}
              </span>
            </span>
            <div className="flex items-center gap-sm">
              <button
                type="button"
                onClick={handleBack}
                disabled={activeStep === 0}
                className={navBtnGhost}
              >
                قبلی
              </button>
              <button
                type="button"
                onClick={handleNext}
                disabled={selectedQuestion.length !== REQUIRED_QUESTIONS}
                className={navBtnPrimary}
              >
                بعدی
              </button>
            </div>
          </div>
        </div>
      ) : activeStep === 1 ? (
        <SectionCard>
          <form onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-6">
                <label htmlFor="ExamName" className="mb-2xs block text-sm text-ink-muted">
                  عنوان آزمون
                </label>
                <TextField
                  name="ExamName"
                  value={call.question_headline}
                  placeholder="عنوان"
                  {...register("ExamName", {
                    required: "عنوان را وارد کنید",
                  })}
                  error={!!errors.ExamName}
                  helperText={errors.ExamName ? errors.ExamName.message : ""}
                  onChange={(e) => {
                    setCall({ ...call, ExamName: e.target.value });
                  }}
                  fullWidth
                />
              </div>
              <div className="mb-6">
                <label htmlFor="exam_headline" className="mb-2xs block text-sm text-ink-muted">
                  مبحث
                </label>
                <FormControl
                  error={errors.exam_headline ? true : false}
                  fullWidth
                >
                  <Select
                    value={call.exam_headline}
                    {...register("exam_headline", {
                      required: "مبحث را وارد کنید",
                    })}
                    fullWidth
                    onChange={(e) => {
                      setCall({ ...call, exam_headline: e.target.value });
                    }}
                  >
                    {lessons.map((lesson) => {
                      return <MenuItem value={lesson}>{lesson}</MenuItem>;
                    })}
                  </Select>
                  <FormHelperText>
                    {errors?.exam_headline?.message}
                  </FormHelperText>
                </FormControl>
              </div>
              <div className="mb-6">
                <label htmlFor="exam_group" className="mb-2xs block text-sm text-ink-muted">
                  گروه
                </label>
                <FormControl error={errors.exam_group ? true : false} fullWidth>
                  <Select
                    value={call.exam_group}
                    {...register("exam_group", {
                      required: "گروه را وارد کنید",
                    })}
                    fullWidth
                    onChange={(e) => {
                      setCall({ ...call, exam_group: e.target.value });
                    }}
                  >
                    {gg?.results.map((g) => {
                      return <MenuItem value={g.id}>{g.name}</MenuItem>;
                    })}
                  </Select>
                  <FormHelperText>{errors?.exam_group?.message}</FormHelperText>
                </FormControl>
              </div>
              <div className="mb-6">
                <label htmlFor="start-day" className="mb-2xs block text-sm text-ink-muted">
                  روز شروع
                </label>
                <FormControl
                  error={errors.exam_available_time_start ? true : false}
                  fullWidth
                >
                  <Controller
                    name="start-day"
                    control={control}
                    render={() => (
                      <MobileDateTimePicker
                        label="روز شروع"
                        value={
                          call.exam_available_time_start
                            ? new Date(call.exam_available_time_start)
                            : null
                        }
                        onChange={(e) => {
                          const date = formatDate(e, "datetime");

                          setCall((prev) => ({
                            ...prev,
                            exam_available_time_start: date,
                          }));
                        }}
                        views={["year", "month", "day", "hours", "minutes"]}
                        viewRenderers={{
                          hours: renderTimeViewClock,
                          minutes: renderTimeViewClock,
                          seconds: renderTimeViewClock,
                        }}
                        className="w-full"
                        ampm={false}
                        slotProps={{
                          field: { shouldRespectLeadingZeros: true },
                          toolbar: { hidden: true },
                          tabs: { hidden: true },
                        }}
                        sx={{
                          "& .PrivatePickersClockNumber-clockNumber": {
                            fontSize: 50,
                          },
                        }}
                      />
                    )}
                  />
                  <FormHelperText>
                    {errors?.assignment_available_time_start?.message}
                  </FormHelperText>
                </FormControl>
              </div>
              <div className="mb-6">
                <label htmlFor="class" className="mb-2xs block text-sm text-ink-muted">
                  پایان
                </label>
                <FormControl
                  error={errors.exam_available_time_end ? true : false}
                  fullWidth
                >
                  <Controller
                    name="end-day"
                    control={control}
                    render={() => (
                      <MobileDateTimePicker
                        label="روز پایان"
                        value={
                          call.exam_available_time_end
                            ? new Date(call.exam_available_time_end)
                            : null
                        }
                        onChange={(e) => {
                          const date = formatDate(e, "datetime");

                          setCall((prev) => ({
                            ...prev,
                            exam_available_time_end: date,
                          }));
                        }}
                        views={["year", "month", "day", "hours", "minutes"]}
                        viewRenderers={{
                          hours: renderTimeViewClock,
                          minutes: renderTimeViewClock,
                          seconds: renderTimeViewClock,
                        }}
                        className="w-full"
                        ampm={false}
                        slotProps={{
                          field: { shouldRespectLeadingZeros: true },
                          toolbar: { hidden: true },
                          tabs: { hidden: true },
                        }}
                        sx={{
                          "& .PrivatePickersClockNumber-clockNumber": {
                            fontSize: 50,
                          },
                        }}
                      />
                    )}
                  />
                  <FormHelperText>
                    {errors?.assignment_available_time_start?.message}
                  </FormHelperText>
                </FormControl>
              </div>
              <div className="mb-6">
                <label htmlFor="exam_maxenterance_time" className="mb-2xs block text-sm text-ink-muted">
                  زمان ورود مجاز آزمون
                </label>
                <FormControl
                  error={errors.exam_maxenterance_time ? true : false}
                  fullWidth
                >
                  <Controller
                    name="max-day"
                    control={control}
                    render={() => (
                      <MobileDateTimePicker
                        label="زمان ورود مجاز آزمون"
                        value={
                          call.exam_maxenterance_time
                            ? new Date(call.exam_maxenterance_time)
                            : null
                        }
                        onChange={(e) => {
                          const date = formatDate(e, "datetime");

                          setCall((prev) => ({
                            ...prev,
                            exam_maxenterance_time: date,
                          }));
                        }}
                        views={["year", "month", "day", "hours", "minutes"]}
                        viewRenderers={{
                          hours: renderTimeViewClock,
                          minutes: renderTimeViewClock,
                          seconds: renderTimeViewClock,
                        }}
                        className="w-full"
                        ampm={false}
                        slotProps={{
                          field: { shouldRespectLeadingZeros: true },
                          toolbar: { hidden: true },
                          tabs: { hidden: true },
                        }}
                        sx={{
                          "& .PrivatePickersClockNumber-clockNumber": {
                            fontSize: 50,
                          },
                        }}
                      />
                    )}
                  />
                  <FormHelperText>
                    {errors?.exam_maxenterance_time?.message}
                  </FormHelperText>
                </FormControl>
              </div>
              <div className="flex flex-wrap items-center justify-between gap-md border-t border-rule-subtle pt-lg">
                <button
                  type="button"
                  onClick={handleBack}
                  className={navBtnGhost}
                >
                  قبلی
                </button>
                <button
                  type="submit"
                  disabled={newExam.loading}
                  className={navBtnPrimary}
                >
                  {newExam.loading ? "در حال ثبت…" : "ثبت آزمون"}
                </button>
              </div>
            </form>
          </SectionCard>
        ) : (
          <SectionCard>
            <p className="py-2xl text-center text-ink-subtle">
              مرحله نامعتبر است.
            </p>
          </SectionCard>
        )}
    </div>
  );
};

export default QuestionCategory;

const lessons = [
  "توابع و خواص آن ها",
  "معادله درجه دوم",
  "الگو و دنباله",
  "مثلثات",
  "توان های گویا و عبارات جبری",
  "مرور توابع و خواص آن ها",
  "آنالیز",
  "احتمالات",
  "هندسه مختصاتی",
  "معادلات و نامعادلات گویا و گنگ",
  "قدر مطلق",
  "براکت",
  "هندسه",
  "توابع نمایی و لگاریتم",
  "حد",
  "پیوستگی",
  "بخش پذیری",
  "مشتق",
  "کاربرد مشتق",
  "مجانب ها",
  "مقاطع مخروطی",
];

const digits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
